import { debounce } from 'debounce'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      page: this.page || 1,
      per_page: this.per_page || 10,
      filter: null,
      isFilterEnabled: false
    }
  },
  computed: {
    ...mapGetters('profile', ['getUserSourcesPermission']),
    ...mapGetters('authentication', ['getUserGuid']),
    isPending () {
      return this.isFindPending && this.list.length === 0
    }
  },
  methods: {
    onPageChange (pagination) {
      this.page = pagination.page + 1
      this.per_page = pagination.per_page
      this.pushState()
      this._fetch()
      window.scrollTo(0, 0)
    },
    onFilter (event) {
      this.filter = event
      this.page = 1
      this.pushState()
      this._fetch()
    },
    onSearch: debounce(function () {
      this.page = 1
      this.pushState()
      this._fetch()
    }, 1000),
    onDateFilter () {
      this.page = 1
      this.pushState()
      this._fetch()
    },
    pushState () {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: this.page.toString(),
          per_page: this.per_page.toString(),
          keyword: this.keyword
        }
      }).catch(_ => {})
    },
    disableFilters () {
      this.$refs.filter.clearAll()
    }
  },
  beforeMount () {
    this.page = (this.$route.query && this.$route.query.page) || this.page
    this.per_page = (this.$route.query && this.$route.query.per_page) || this.per_page
  }
}
